interface NotFoundProps {
    message?: string;
}

const NotFound = ({ message = 'Page not found' }: NotFoundProps) => (
    <h1 style={{ margin: 'auto' }}>{message}</h1>
);

export default NotFound;
